import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { Locations } from '../types/Locations';

export async function getShiftLocations(): Promise<Locations[]> {
    try {
        const apiLocations: Locations[] = await fetchFromLambda('/organisation/locations');

        // Function to flatten the location hierarchy
        const flattenLocations = (locations: Locations[]): Locations[] => {
            const flattened: Locations[] = [];

            locations.forEach((location) => {
                // Add the parent location
                flattened.push({
                    _id: location._id,
                    name: location.name,
                    description: location.description,
                    parentLocationId: location.parentLocationId,
                    color: location.color,
                    organisationId: location.organisationId,
                    __v: location.__v,
                    originalId: location.originalId,
                    originalParentId: location.originalParentId,
                    childLocations: []
                });

                // Add child locations if they exist
                if (location.childLocations && location.childLocations.length > 0) {
                    const childLocations = flattenLocations(location.childLocations);
                    flattened.push(...childLocations);
                }
            });

            return flattened;
        };

        const flattenedLocations = flattenLocations(apiLocations);

        return flattenedLocations.sort((a, b) => a.name.localeCompare(b.name));
   
    } catch {
        return [];
    }
}
